import request from '@/utils/request'


// 查询运动信息列表
export function listExercise(query) {
  return request({
    url: '/exercise/exercise/list',
    method: 'get',
    params: query
  })
}

// 查询运动信息分页
export function pageExercise(query) {
  return request({
    url: '/exercise/exercise/page',
    method: 'get',
    params: query
  })
}

// 查询运动信息详细
export function getExercise(data) {
  return request({
    url: '/exercise/exercise/detail',
    method: 'get',
    params: data
  })
}

// 新增运动信息
export function addExercise(data) {
  return request({
    url: '/exercise/exercise/add',
    method: 'post',
    data: data
  })
}

// 修改运动信息
export function updateExercise(data) {
  return request({
    url: '/exercise/exercise/edit',
    method: 'post',
    data: data
  })
}

// 删除运动信息
export function delExercise(data) {
  return request({
    url: '/exercise/exercise/delete',
    method: 'post',
    data: data
  })
}
